import React, { useEffect, useState, useMemo, useRef } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import Breadcrumb from "../Components/Breadcrumb";
import {
  FiBriefcase,
  FiPhone,
  FiMail,
  FiMapPin,
  FiMessageSquare,
  FiCalendar,
  FiClock,
  FiChevronLeft,
  FiChevronRight,
  FiUser,
  FiFileText,
  FiCheck,
  FiArrowRight,
} from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import SchemaMarkup from "../Components/SchemaMarkup";
import WebPageSchema from "../Schema/WebpageSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
/*const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
    filter: "blur(8px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
    },
  },
};

const setupOptions = [
  "I have a business website",
  "I have a GST Registration",
  "I have a fresh/unused WhatsApp number",
  "I have a Facebook account",
  "I have a Meta Business Portfolio",
  "I've used WhatsApp for Business before",  
];

const industries = [
  "E-commerce & D2C",
  "Healthcare & Clinics",
  "Real Estate",
  "Finance & Insurance",
  "Restaurants & F&B",
  "Retail Stores",
  "Automobile Dealers",
  "Salons & Spas",
  "Events & Webinars",
  "Other",
];*/

/*const BookDemo=()=>{

useEffect(() => {
    document.title =
      "Contact ONBBITS | Book a WhatsApp Automation Demo";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Contact ONBBITS to schedule a demo, get expert guidance or learn how WhatsApp Business API automation can help your business grow."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://onbbits.io/book-a-demo");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Contact ONBBITS | Book a WhatsApp Automation Demo"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Contact ONBBITS to schedule a demo, get expert guidance or learn how WhatsApp Business API automation can help your business grow."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://onbbits.io/book-a-demo");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://onbbits.io/Images/agent-management.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Contact ONBBITS | Book a WhatsApp Automation Demo"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Contact ONBBITS to schedule a demo, get expert guidance or learn how WhatsApp Business API automation can help your business grow."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://onbbits.io/Images/agent-management.webp"
    );
  }
  }, [])

  const [loading, setLoading] = useState(false);
  const generateToken = useRecaptcha();

const [formData, setFormData] = useState({
    name: "",
    businessName: "",
    whatsapp: "",
    email: "",
    industry: "",
    setup: [],
    challenge: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSetupChange = (option) => {
    setFormData((prev) => ({
      ...prev,
      setup: prev.setup.includes(option)
        ? prev.setup.filter((item) => item !== option)
        : [...prev.setup, option],
    }));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

if (!formData.name.trim()) {
    toast.error("Please enter your name");
    return;
  }

  if (!formData.businessName.trim()) {
    toast.error("Please enter your business name");
    return;
  }

  if (!formData.whatsapp.trim()) {
    toast.error("Please enter your WhatsApp number");
    return;
  }

  if (!formData.email.trim()) {
    toast.error("Please enter your work email");
    return;
  }

  if (!formData.industry) {
    toast.error("Please select your industry");
    return;
  }

  setLoading(true);
  generateToken(async (token) => {
  try {
 const recaptchaData = new FormData();

      recaptchaData.append(
        "secret",
        "6Le8-4ktAAAAACnqexkKznBsqgEu7kvPLemu9hUT"
      );

      recaptchaData.append(
        "response",
        token
      );

      const verifyRes = await axios.post(
        "https://api.sendmail.adhyaynam.in/recaptcha-verify",
        recaptchaData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      console.log(
        "FULL RESPONSE:",
        verifyRes.data
      );

      const score =
        verifyRes.data.score ||
        verifyRes.data.data?.score;

      console.log(
        "Recaptcha Score:",
        score
      );

      // ✅ BLOCK SPAM
      if (!score || score <= 0.5) {

        toast.error(
          "Spam detected. Please try again."
        );

        setLoading(false);

        return;
      }

const setupList =
  formData.setup.length > 0
    ? formData.setup
        .map(
          (item) => `
            <p style="
              margin:0 0 7px;
              color:#000000;
              font-family:'Poppins',Arial,Helvetica,sans-serif;
              font-size:12px;
              line-height:1.6;
              font-weight:400;
            ">
              <span style="
                color:#0FAE4D;
                font-weight:600;
              ">✓</span>
              &nbsp;${item}
            </p>
          `
        )
        .join("")
    : `
      <p style="
        margin:0;
        color:#282828;
        font-family:'Poppins',Arial,Helvetica,sans-serif;
        font-size:12px;
        line-height:1.6;
      ">
        No setup information selected
      </p>
    `;
    
const template = `
  <div style="
    margin:0;
    padding:30px 15px;
    background:#ffffff;
    font-family:'Poppins',Arial,Helvetica,sans-serif;
  ">

    <table
      width="100%"
      cellpadding="0"
      cellspacing="0"
      border="0"
    >
      <tr>
        <td align="center">

          <!-- MAIN CONTAINER -->
          <table
            width="600"
            cellpadding="0"
            cellspacing="0"
            border="0"
            style="
              width:100%;
              max-width:600px;
              background:#ffffff;
              border:2px solid #0FAE4D;
            "
          >

            <!-- HEADER -->
            <tr>
              <td
                align="center"
                style="
                  background:#0FAE4D;
                  padding:28px 25px;
                "
              >

                <img
                  src="https://onbbits.io/logo-white.svg"
                  alt="ONBBITS"
                  width="145"
                  style="
                    display:block;
                    width:145px;
                    max-width:100%;
                    height:auto;
                    margin:0 auto 18px;
                  "
                />

                <h1
                  style="
                    margin:0;
                    padding:0;
                    color:#ffffff;
                    font-family:'Poppins',Arial,Helvetica,sans-serif;
                    font-size:22px;
                    line-height:1.4;
                    font-weight:600;
                  "
                >
                  New Demo Request
                </h1>

              </td>
            </tr>


            <!-- CONTENT -->
            <tr>
              <td
                style="
                  padding:28px;
                  background:#ffffff;
                "
              >

                <!-- INTRO -->
                <p
                  style="
                    margin:0 0 22px;
                    color:#000000;
                    font-family:'Poppins',Arial,Helvetica,sans-serif;
                    font-size:13px;
                    line-height:1.7;
                  "
                >
                  A new demo request has been submitted through the ONBBITS website.
                </p>


                <!-- CONTACT INFORMATION -->
                <table
                  width="100%"
                  cellpadding="0"
                  cellspacing="0"
                  border="0"
                  style="
                    border:1px solid #282828;
                  "
                >

                  <tr>
                    <td
                      colspan="2"
                      style="
                        padding:12px 15px;
                        background:#EFFFF5;
                        border-bottom:1px solid #282828;
                      "
                    >
                      <p
                        style="
                          margin:0;
                          color:#282828;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:14px;
                          line-height:1.4;
                          font-weight:600;
                        "
                      >
                        Contact Information
                      </p>
                    </td>
                  </tr>


                  <!-- NAME -->
                  <tr>

                    <td
                      width="50%"
                      style="
                        padding:15px;
                        border-bottom:1px solid #EFFFF5;
                        border-right:1px solid #EFFFF5;
                        vertical-align:top;
                      "
                    >
                      <p
                        style="
                          margin:0 0 4px;
                          color:#282828;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:10px;
                          line-height:1.4;
                          font-weight:500;
                          text-transform:uppercase;
                        "
                      >
                        Name
                      </p>

                      <p
                        style="
                          margin:0;
                          color:#000000;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:13px;
                          line-height:1.5;
                          font-weight:500;
                        "
                      >
                        ${formData.name}
                      </p>
                    </td>


                    <!-- BUSINESS -->
                    <td
                      width="50%"
                      style="
                        padding:15px;
                        border-bottom:1px solid #EFFFF5;
                        vertical-align:top;
                      "
                    >
                      <p
                        style="
                          margin:0 0 4px;
                          color:#282828;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:10px;
                          line-height:1.4;
                          font-weight:500;
                          text-transform:uppercase;
                        "
                      >
                        Business Name
                      </p>

                      <p
                        style="
                          margin:0;
                          color:#000000;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:13px;
                          line-height:1.5;
                          font-weight:500;
                        "
                      >
                        ${formData.businessName}
                      </p>
                    </td>

                  </tr>


                  <!-- WHATSAPP -->
                  <tr>

                    <td
                      width="50%"
                      style="
                        padding:15px;
                        border-bottom:1px solid #EFFFF5;
                        border-right:1px solid #EFFFF5;
                        vertical-align:top;
                      "
                    >
                      <p
                        style="
                          margin:0 0 4px;
                          color:#282828;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:10px;
                          line-height:1.4;
                          font-weight:500;
                          text-transform:uppercase;
                        "
                      >
                        WhatsApp Number
                      </p>

                      <p
                        style="
                          margin:0;
                          color:#000000;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:13px;
                          line-height:1.5;
                          font-weight:500;
                        "
                      >
                        ${formData.whatsapp}
                      </p>
                    </td>


                    <!-- EMAIL -->
                    <td
                      width="50%"
                      style="
                        padding:15px;
                        border-bottom:1px solid #EFFFF5;
                        vertical-align:top;
                      "
                    >
                      <p
                        style="
                          margin:0 0 4px;
                          color:#282828;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:10px;
                          line-height:1.4;
                          font-weight:500;
                          text-transform:uppercase;
                        "
                      >
                        Work Email
                      </p>

                      <p
                        style="
                          margin:0;
                          color:#000000;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:13px;
                          line-height:1.5;
                          font-weight:500;
                          word-break:break-word;
                        "
                      >
                        ${formData.email}
                      </p>
                    </td>

                  </tr>


                  <!-- INDUSTRY -->
                  <tr>

                    <td
                      colspan="2"
                      style="
                        padding:15px;
                        vertical-align:top;
                      "
                    >
                      <p
                        style="
                          margin:0 0 4px;
                          color:#282828;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:10px;
                          line-height:1.4;
                          font-weight:500;
                          text-transform:uppercase;
                        "
                      >
                        Industry
                      </p>

                      <p
                        style="
                          margin:0;
                          color:#000000;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:13px;
                          line-height:1.5;
                          font-weight:500;
                        "
                      >
                        ${formData.industry}
                      </p>
                    </td>

                  </tr>

                </table>


                <!-- CURRENT SETUP -->
                <table
                  width="100%"
                  cellpadding="0"
                  cellspacing="0"
                  border="0"
                  style="
                    margin-top:20px;
                    border:1px solid #282828;
                  "
                >

                  <tr>
                    <td
                      style="
                        padding:12px 15px;
                        background:#EFFFF5;
                        border-bottom:1px solid #282828;
                      "
                    >
                      <p
                        style="
                          margin:0;
                          color:#282828;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:14px;
                          line-height:1.4;
                          font-weight:600;
                        "
                      >
                        Current Setup
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td
                      style="
                        padding:15px;
                      "
                    >
                      ${setupList}
                    </td>
                  </tr>

                </table>


                <!-- CHALLENGE -->
                <table
                  width="100%"
                  cellpadding="0"
                  cellspacing="0"
                  border="0"
                  style="
                    margin-top:20px;
                    border:1px solid #282828;
                  "
                >

                  <tr>
                    <td
                      style="
                        padding:12px 15px;
                        background:#EFFFF5;
                        border-bottom:1px solid #282828;
                      "
                    >
                      <p
                        style="
                          margin:0;
                          color:#282828;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:14px;
                          line-height:1.4;
                          font-weight:600;
                        "
                      >
                        Biggest Challenge / Goal
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td
                      style="
                        padding:15px;
                      "
                    >
                      <p
                        style="
                          margin:0;
                          color:#000000;
                          font-family:'Poppins',Arial,Helvetica,sans-serif;
                          font-size:13px;
                          line-height:1.7;
                          font-weight:400;
                        "
                      >
                        ${
                          formData.challenge.trim()
                            ? formData.challenge
                            : "No challenge or goal provided."
                        }
                      </p>
                    </td>
                  </tr>

                </table>

              </td>
            </tr>


            <!-- FOOTER -->
            <tr>
              <td
                align="center"
                style="
                  background:#0FAE4D;
                  padding:20px 25px;
                "
              >

                <p
                  style="
                    margin:0;
                    color:#ffffff;
                    font-family:'Poppins',Arial,Helvetica,sans-serif;
                    font-size:14px;
                    line-height:1.5;
                    font-weight:600;
                  "
                >
                  ONBBITS
                </p>

                <p
                  style="
                    margin:4px 0 0;
                    color:#ffffff;
                    font-family:'Poppins',Arial,Helvetica,sans-serif;
                    font-size:10px;
                    line-height:1.5;
                    font-weight:400;
                  "
                >
                  WhatsApp Business Automation Platform
                </p>

                <p
                  style="
                    margin:8px 0 0;
                    color:#ffffff;
                    font-family:'Poppins',Arial,Helvetica,sans-serif;
                    font-size:9px;
                    line-height:1.5;
                    font-weight:400;
                  "
                >
                  © ${new Date().getFullYear()} ONBBITS. All rights reserved.
                </p>

              </td>
            </tr>

          </table>

        </td>
      </tr>
    </table>

  </div>
`;


    /*
    ==========================================
    FORM DATA FOR API
    ==========================================
   

    const data = new FormData();

    data.append(
      "title",
      "ONBBITS Book Demo Form"
    );

    data.append(
      "to_email",
      "sales@onbbits.io"
    );

    data.append(
      "cc",
      "arkayappsseo@gmail.com,sales@arkayapps.com"
    );

    data.append(
      "subject",
      "ONBBITS New Demo Request"
    );

    data.append(
      "template",
      template
    );


    /*
    ==========================================
    SEND EMAIL
    ==========================================


    await axios.post(
      "https://api.sendmail.adhyaynam.in/send-mail/two",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );


    /*
    ==========================================
    SUCCESS
    ==========================================
 

    toast.success("Demo request submitted successfully!");

    setFormData({
      name: "",
      businessName: "",
      whatsapp: "",
      email: "",
      industry: "",
      setup: [],
      challenge: "",
    });

  } catch (error) {
  
        console.log(
          error.response?.data || error
        );
  
        toast.error(
          "Verification failed. Please try again!"
        );
  
      } finally {
  
        setLoading(false);
  
      }
    })
    };
  
    return(
        <>

<ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnHover
      theme="light"
    />

    <SchemaMarkup
  data={WebPageSchema({
    type: "WebPage",
    name: "Book a Demo | ONBBITS",
    description:
      "Book a demo of ONBBITS and discover how WhatsApp Business API, automation, customer engagement, and messaging solutions can help your business grow.",
    url: "https://onbbits.io/book-a-demo"
  })}
/>

<SchemaMarkup
  data={BreadcrumbSchema({
    items: [
      {
        name: "Home",
        url: "https://onbbits.io/"
      },
      {
        name: "Book a Demo",
        url: "https://onbbits.io/book-a-demo"
      }
    ]
  })}
/>


        {/**BREADCRUMB 
        <Breadcrumb title="Book a Demo" />

        {/**DEMO FORM SECTION 
        <section className="book-demo-section">

      <div className="container">

        <div className="book-demo-grid">

          {/* =====================================================
              LEFT SIDE
          ======================================================

          <motion.div
            className="book-demo-left"
            variants={stagger}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.15,
            }}
          >
               <div className="book-demo-form-header">
              <h2 className="section-heading">
                Book your live demo
              </h2>

              <p className="section-text">
                Tell us about your business and we'll set up
                your first automation flow live — no commitment,
                no credit card.
              </p>

            </div>

            {/* Contact Card
             <motion.div
                className="contact-card"
                variants={fadeUp}
                whileHover={{ y: -6 }}
                transition={{ duration: 0.2 }}
              >
              <div className="contact-icon">
                <FiMessageSquare />
              </div>
              <h3 className="card-heading">Chat with sales</h3>
              <p className="section-text">Talk to us on WhatsApp. We're available Mon–Sat, 9am to 7pm IST.</p>
            <a
  href={`https://wa.me/919727077732?text=${encodeURIComponent(
    "Hi ONBBITS Team,\n\nI'm interested in learning more about your WhatsApp automation platform. Could you please assist me?"
  )}`}
  target="_blank"
  rel="noopener noreferrer"
  className="contact-link"
>
  Chat on WhatsApp
  <FiArrowRight />
</a>
              </motion.div>


            {/* Contact Details 

            <motion.div
              className="contact-card card-2"
              variants={fadeUp}
              whileHover={{ y: -6 }}
              transition={{ duration: 0.2 }}
            >

              <h3 className="card-heading">
                Prefer to reach us directly?
              </h3>

              {/* WhatsApp

              <div className="contact-info-item">

                <div className="contact-icon-box">
                  <FiPhone />
                </div>

                <div className="contact-info-content">

                 <a href="tel:+919727077732">
  +91 97270 77732
</a>
                </div>

              </div>


              {/* Email 

              <div className="contact-info-item">

                <div className="contact-icon-box">
                  <FiMail />
                </div>

                <div className="contact-info-content">

                  <a href="mailto:info@onbbits.io">
                    info@onbbits.io
                  </a>

                </div>

              </div>


              {/* Location 

              <div className="contact-info-item">

                <div className="contact-icon-box">
                  <FiMapPin />
                </div>

                <div className="contact-info-content">


                  <p className="section-text">
                  912, International Finance Center, VIP Road, Vesu, Surat, Gujarat 395007
                  </p>

                </div>

              </div>

            </motion.div>

          </motion.div>


          {/* =====================================================
              RIGHT SIDE — FORM
          ====================================================== 

          <motion.div
  className="contact-right"
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{
    once: true,
    amount: 0.1,
  }}
>
  <form onSubmit={handleSubmit}>

    <motion.div
      className="form-grid"
      variants={stagger}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >

      {/* NAME 
      <motion.div
        className="input-group"
        variants={fadeUp}
      >
        <label htmlFor="name">
          Your Name *
        </label>

        <div className="input-box">
          <FiUser />

          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter Your Name"
          />
        </div>
      </motion.div>


      {/* BUSINESS NAME 
      <motion.div
        className="input-group"
        variants={fadeUp}
      >
        <label htmlFor="businessName">
          Business Name *
        </label>

        <div className="input-box">
          <FiBriefcase />

          <input
            type="text"
            id="businessName"
            name="businessName"
            value={formData.businessName}
            onChange={handleChange}
            placeholder="Enter Your Business Name"
          />
        </div>
      </motion.div>


      {/* WHATSAPP 
      <motion.div
        className="input-group"
        variants={fadeUp}
      >
        <label htmlFor="whatsapp">
          WhatsApp Number *
        </label>

        <div className="input-box">
          <FiPhone />

          <input
            type="tel"
            id="whatsapp"
            name="whatsapp"
            value={formData.whatsapp}
            onChange={handleChange}
            placeholder="+91 98765 43210"
          />
        </div>
      </motion.div>


      {/* EMAIL 
      <motion.div
        className="input-group"
        variants={fadeUp}
      >
        <label htmlFor="email">
          Work Email *
        </label>

        <div className="input-box">
          <FiMail />

          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="you@business.com"
          />
        </div>
      </motion.div>


      {/* INDUSTRY 
      <motion.div
        className="input-group full-width"
        variants={fadeUp}
      >
        <label htmlFor="industry">
          Your Industry *
        </label>

        <div className="input-box">
          <select
            id="industry"
            name="industry"
            value={formData.industry}
            onChange={handleChange}
          >
            <option value="">
              Select Your Industry
            </option>

            {industries.map((industry) => (
              <option
                value={industry}
                key={industry}
              >
                {industry}
              </option>
            ))}
          </select>
        </div>
      </motion.div>


      {/* SETUP 
      <motion.div
        className="input-group full-width"
        variants={fadeUp}
      >
        <label>
          Tell Us Your Setup
          <span> · tick all that apply</span>
        </label>

        <div className="setup-options">

          {setupOptions.map((option) => {

            const checked =
              formData.setup.includes(option);

            return (
             <label
  className={`setup-option ${
    checked ? "checked" : ""
  }`}
  key={option}
>
  <input
    type="checkbox"
    checked={checked}
    onChange={() => handleSetupChange(option)}
  />

  <span className="custom-checkbox">
    {checked && <FiCheck />}
  </span>

  <span className="setup-option-text">
    {option}
  </span>
</label>
            );

          })}

        </div>
      </motion.div>


      {/* CHALLENGE / GOAL 
      <motion.div
        className="input-group full-width"
        variants={fadeUp}
      >
        <label htmlFor="challenge">
          Your Biggest Challenge or Goal
        </label>

        <div className="input-box textarea">
          <FiMessageSquare />

          <textarea
            id="challenge"
            name="challenge"
            rows="5"
            value={formData.challenge}
            onChange={handleChange}
            placeholder="e.g. We get plenty of WhatsApp enquiries but miss follow-ups and lose leads."
          />
        </div>
      </motion.div>

    </motion.div>


    {/* BUTTON 
    <motion.button
  className="contact-btn btn btn-primary"
  type="submit"
  disabled={loading}
  variants={fadeUp}
  whileHover={{
    y: loading ? 0 : -4,
  }}
  whileTap={{
    scale: loading ? 1 : 0.97,
  }}
  transition={{
    duration: 0.2,
  }}
>
  {loading ? "Sending..." : "Book My Demo"}
  
  {!loading && <FiArrowRight />}
</motion.button>

  </form>
</motion.div>

        </div>

      </div>

    </section>
        </>
    )
}
export default BookDemo;*/

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
    filter: "blur(8px)",
  },

  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",

    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

  const stagger = {
    hidden: {},

    visible: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  };


const BookDemo = () => {

  const [loading, setLoading] = useState(false);
  const bookingSectionRef = useRef(null);
  const [bookingStep, setBookingStep] = useState(1);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [timeSlots, setTimeSlots] = useState([]);
  const [slotsLoading, setSlotsLoading] = useState(false);
  const [slotsError, setSlotsError] = useState("");

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [calendarMonth, setCalendarMonth] = useState(
    new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    )
  );

const [formData, setFormData] = useState({
  companyName: "",
  workEmail: "",
  fullName: "",
  phoneNumber: "",
  projectBrief: "",
  howDidYouFindUs: [],
});

  useEffect(() => {

    document.title = "Contact ONBBITS | Book a WhatsApp Automation Demo";
    const metaDescription =
      document.querySelector(
        'meta[name="description"]'
      );
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Contact ONBBITS to schedule a demo, get expert guidance or learn how WhatsApp Business API automation can help your business grow."
      );
    }

    const canonical =
      document.querySelector(
        'link[rel="canonical"]'
      );
    if (canonical) {
      canonical.setAttribute(
        "href",
        "https://onbbits.io/book-a-demo"
      );
    }

    const ogTitle =
      document.querySelector(
        'meta[property="og:title"]'
      );
    if (ogTitle) {
      ogTitle.setAttribute(
        "content",
        "Contact ONBBITS | Book a WhatsApp Automation Demo"
      );
    }

    const ogDescription =
      document.querySelector(
        'meta[property="og:description"]'
      );
    if (ogDescription) {
      ogDescription.setAttribute(
        "content",
        "Contact ONBBITS to schedule a demo, get expert guidance or learn how WhatsApp Business API automation can help your business grow."
      );
    }

    const ogUrl =
      document.querySelector(
        'meta[property="og:url"]'
      );
    if (ogUrl) {
      ogUrl.setAttribute(
        "content",
        "https://onbbits.io/book-a-demo"
      );
    }

    const ogImage =
      document.querySelector(
        'meta[property="og:image"]'
      );
    if (ogImage) {
      ogImage.setAttribute(
        "content",
        "https://onbbits.io/Images/agent-management.webp"
      );
    }

    const twitterTitle =
      document.querySelector(
        'meta[name="twitter:title"]'
      );
    if (twitterTitle) {
      twitterTitle.setAttribute(
        "content",
        "Contact ONBBITS to schedule a demo, get expert guidance or learn how WhatsApp Business API automation can help your business grow."
      );
    }

    const twitterDescription =
      document.querySelector(
        'meta[name="twitter:description"]'
      );
    if (twitterDescription) {
      twitterDescription.setAttribute(
        "content",
        "Book a live demo with ONBBITS and discover how WhatsApp automation can help your business grow."
      );
    }

    const twitterImage =
      document.querySelector(
        'meta[name="twitter:image"]'
      );
    if (twitterImage) {
      twitterImage.setAttribute(
        "content",
        "https://onbbits.io/Images/agent-management.webp"
      );
    }
  }, []);

  const handleChange = (e) => {
    const {
      name,
      value,
    } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

  };


  const formatSelectedDate = (
    dateString
  ) => {
    if (!dateString) return "";
    const date = new Date(
      `${dateString}T00:00:00`
    );
    return date.toLocaleDateString(
      "en-IN",
      {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      }
    );
  };

  const formatDateString = (
    year,
    month,
    day
  ) => {
    const monthString = String(
      month + 1
    ).padStart(2, "0");

    const dayString = String(
      day
    ).padStart(2, "0");

    return `${year}-${monthString}-${dayString}`;
  };

  const formatBookingDate = (dateString) => {
  if (!dateString) return "";

  const [year, month, day] = dateString.split("-");

  return `${day}-${month}-${year}`;
};

  const calendarDays = useMemo(() => {
    const year =
      calendarMonth.getFullYear();
    const month =
      calendarMonth.getMonth();
    const firstDay = new Date(
      year,
      month,
      1
    );
    const firstDayIndex =
      firstDay.getDay();

    const daysInMonth =
      new Date(
        year,
        month + 1,
        0
      ).getDate();

    const previousMonthDays =
      new Date(
        year,
        month,
        0
      ).getDate();

    const days = [];

    for (
      let i = firstDayIndex - 1;
      i >= 0;
      i--
    ) {

      const day =
        previousMonthDays - i;

      days.push({
        day,
        date: null,
        currentMonth: false,
      });

    }

    for (
      let day = 1;
      day <= daysInMonth;
      day++
    ) {
      days.push({
        day,
        date: formatDateString(
          year,
          month,
          day
        ),
        currentMonth: true,
      });
    }

    const remaining =
      42 - days.length;

    for (
      let day = 1;
      day <= remaining;
      day++
    ) {

      days.push({
        day,
        date: null,
        currentMonth: false,
      });

    }
    return days;
  }, [calendarMonth]);

  const calendarMonthName =
    calendarMonth.toLocaleDateString(
      "en-IN",
      {
        month: "long",
        year: "numeric",
      }
    );

  const handlePreviousMonth = () => {
    const previousMonth =
      new Date(
        calendarMonth.getFullYear(),
        calendarMonth.getMonth() - 1,
        1
      );

    const currentMonth =
      new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );

    if (
      previousMonth < currentMonth
    ) {
      return;
    }

    setCalendarMonth(
      previousMonth
    );

  };

  const handleNextMonth = () => {
    setCalendarMonth(
      new Date(
        calendarMonth.getFullYear(),
        calendarMonth.getMonth() + 1,
        1
      )
    );
  };

  const isPastDate = (dateString) => {
    if (!dateString) return true;
    const date = new Date(
      `${dateString}T00:00:00`
    );
    return date < today;
  };

const handleDateSelect = async (dateString) => {
  if (!dateString || isPastDate(dateString)) return;

  setSelectedDate(dateString);
  setSelectedTime("");
  setTimeSlots([]);
  setSlotsError("");
  setSlotsLoading(true);

  try {
    const response = await axios.get(
      "https://api.onbbits.io/api/get-available-slots",
      {
        params: {
          date: dateString,
        },
      }
    );

    setTimeSlots(
      Array.isArray(response.data) ? response.data : []
    );
  } catch (error) {
    console.error("Error fetching available slots:", error);
    setSlotsError("Unable to load available time slots. Please try again.");
  } finally {
    setSlotsLoading(false);
  }
};

  const handleNextStep = () => {
  if (!selectedDate) {
    toast.error("Please select a date.");
    return;
  }

  if (!selectedTime) {
    toast.error("Please select a time slot.");
    return;
  }

  setBookingStep(2);

  setTimeout(() => {
    bookingSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, 100);
};


const handleBookingSubmit = async (e) => {
  e.preventDefault();

  // Validate required fields
  if (!selectedDate || !selectedTime) {
    toast.error("Please select a date and time slot.");
    setBookingStep(1);
    return;
  }

  if (!formData.companyName.trim()) {
    toast.error("Please enter your company name.");
    setBookingStep(1);
    return;
  }

  if (!formData.workEmail.trim()) {
    toast.error("Please enter your work email.");
    setBookingStep(1);
    return;
  }

  if (!formData.fullName.trim()) {
    toast.error("Please enter your full name.");
    return;
  }

  if (!formData.phoneNumber.trim()) {
    toast.error("Please enter your phone number.");
    return;
  }

  if (!formData.projectBrief.trim()) {
    toast.error("Please enter your project brief.");
    return;
  }

  if (formData.howDidYouFindUs.length === 0) {
    toast.error("Please select how you found us.");
    return;
  }

  const payload = {
    date: formatBookingDate(selectedDate),
    slot: selectedTime,
    email: formData.workEmail.trim(),
    description: `Company Name: ${formData.companyName.trim()}\n Name: ${formData.fullName.trim()}\n Contact Number: ${formData.phoneNumber.trim()}\n Project Brief: ${formData.projectBrief.trim()}\nHow did you find us: ${formData.howDidYouFindUs.join(", ")}`,
    booking_type: "Demo",
  };

  setLoading(true);

 try {
const leadPayload = {
  name: formData.fullName.trim(),
  email: formData.workEmail.trim(),
  phone_no: formData.phoneNumber.trim(),
  company_name: formData.companyName.trim(),
  message: `Project Brief: ${formData.projectBrief.trim()}\n How did you find us: ${formData.howDidYouFindUs.join(", ")}`,
  lead_source: "Website",
};

  const leadResponse = await axios.post(
    "https://api.onbbits.io/api/meta/lead",
    leadPayload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  // Continue only if the lead API confirms success
  if (leadResponse.data?.success === false) {
    throw new Error(
      leadResponse.data?.error || "Unable to create lead."
    );
  }

    const bookingResponse = await axios.post(
      "https://api.onbbits.io/api/demobook-onboarding-event",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    toast.success(
      bookingResponse.data?.message || "Your demo booking has been submitted successfully!"
    );

    setFormData({
  companyName: "",
  workEmail: "",
  fullName: "",
  phoneNumber: "",
  projectBrief: "",
  howDidYouFindUs: [],
});

setSelectedDate("");
setSelectedTime("");
setTimeSlots([]);
setSlotsError("");

setBookingStep(1);

  } catch (error) {
    console.error("Demo booking error:", error);

    toast.error(
      error.response?.data?.message ||
      "Unable to book your demo. Please try again."
    );
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      <ToastContainer />
 
      <SchemaMarkup
        data={WebPageSchema({
          type: "WebPage",
          name:
            "Book a Demo | ONBBITS",
          description:
            "Book a demo of ONBBITS and discover how WhatsApp Business API, automation, customer engagement, and messaging solutions can help your business grow.",
          url:
            "https://onbbits.io/book-a-demo",
        })}
      />

      <SchemaMarkup
        data={BreadcrumbSchema({
          items: [
            {
              name: "Home",
              url:
                "https://onbbits.io/",
            },
            {
              name: "Book a Demo",
              url:
                "https://onbbits.io/book-a-demo",
            },
          ],
        })}
      />

      <Breadcrumb
        title="Book a Demo"
        currentPage="Book a Demo"
      />

<section className="book-demo-section"
ref={bookingSectionRef}>

  <div className="container">

    <div className="book-demo-grid">


      {/* =====================================
          LEFT SIDE
      ====================================== */}

      <motion.div
        className="book-demo-left"

        variants={stagger}

        initial="hidden"

        whileInView="visible"

        viewport={{
          once: true,
          amount: 0.15,
        }}
      >

        <div className="book-demo-form-header">

          <h2 className="section-heading">
            Book your live demo
          </h2>


          <p className="section-text">
            Tell us about your business and
            we'll set up your first automation
            flow live — no commitment,
            no credit card.
          </p>

        </div>

        <motion.div
          className="contact-card"
          variants={fadeUp}
          whileHover={{
            y: -6,
          }}
          transition={{
            duration: 0.2,
          }}
        >

          <div className="contact-icon">
            <FiMessageSquare />
          </div>

          <h3 className="card-heading">
            Chat with sales
          </h3>


          <p className="section-text">
            Talk to us on WhatsApp.
            We're available Mon–Sat,
            9am to 7pm IST.
          </p>


          <a
            href={`https://wa.me/919727077732?text=${encodeURIComponent(
              "Hi ONBBITS Team,\n\nI'm interested in learning more about your WhatsApp automation platform. Could you please assist me?"
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            Chat on WhatsApp
            <FiArrowRight />
          </a>
        </motion.div>

        <motion.div
          className="contact-card card-2"
          variants={fadeUp}
          whileHover={{
            y: -6,
          }}
          transition={{
            duration: 0.2,
          }}
        >

          <h3 className="card-heading">
            Prefer to reach us directly?
          </h3>

          <div className="contact-info-item">
            <div className="contact-icon-box">
              <FiPhone />
            </div>

            <div className="contact-info-content">
              <a href="tel:+919727077732">
                +91 97270 77732
              </a>
            </div>
          </div>

          <div className="contact-info-item">
            <div className="contact-icon-box">
              <FiMail />
            </div>

            <div className="contact-info-content">
              <a href="mailto:info@onbbits.io">
                info@onbbits.io
              </a>
            </div>
          </div>

          <div className="contact-info-item">
            <div className="contact-icon-box">
              <FiMapPin />
            </div>

            <div className="contact-info-content">
              <p className="section-text">
                912, International Finance
                Center, VIP Road, Vesu,
                Surat, Gujarat 395007
              </p>
            </div>
          </div>
        </motion.div>
      </motion.div>


      {/* =====================================
          RIGHT SIDE
      ====================================== */}

      <motion.div
        className=""

        initial={{
          opacity: 0,
          x: 30,
        }}

        whileInView={{
          opacity: 1,
          x: 0,
        }}

        viewport={{
          once: true,
          amount: 0.2,
        }}

        transition={{
          duration: 0.7,
          ease: "easeOut",
        }}
      >


        {/* =====================================
            STEP 1
        ====================================== */}

        {bookingStep === 1 && (

          <div className="booking-step">
            <div className="booking-step-header">
              <div>
                <h2 className="section-heading">
                  Choose a date & time
                </h2>
           <p className="section-text">
  Choose a convenient date and time for your live demo,
  and we’ll make sure the session is tailored to your
  business needs and requirements.
</p>
              </div>
            </div>

            <div className="book-demo-right">
              <div className="booking-selection-grid">
                <div className="booking-calendar-column">
                  <div className="booking-field">
                    <label>
                      <FiCalendar />
                      Select a date
                    </label>
                    <div className="calendar-wrapper">
                      <div className="calendar-header">
                        <button
                          type="button"
                          className="calendar-nav"
                          onClick={
                            handlePreviousMonth
                          }
                          disabled={
                            calendarMonth.getMonth() ===
                              today.getMonth() &&
                            calendarMonth.getFullYear() ===
                              today.getFullYear()
                          }
                          aria-label="Previous month"
                        >
                          <FiChevronLeft />
                        </button>

                        <h3>
                          {calendarMonthName}
                        </h3>

                        <button
                          type="button"
                          className="calendar-nav"
                          onClick={
                            handleNextMonth
                          }
                          aria-label="Next month"
                        >
                          <FiChevronRight />
                        </button>
                      </div>

                      <div className="calendar-weekdays">
                        {[
                          "Sun",
                          "Mon",
                          "Tue",
                          "Wed",
                          "Thu",
                          "Fri",
                          "Sat",
                        ].map(
                          (day) => (
                            <span
                              key={day}
                            >
                              {day}
                            </span>
                          )
                        )}
                      </div>

                      <div className="calendar-grid">
                        {calendarDays.map(
                          (
                            item,
                            index
                          ) => {

                            const isSelected =
                              selectedDate ===
                              item.date;


                            const isPast =
                              item.date &&
                              isPastDate(
                                item.date
                              );


                            const isToday =
                              item.date ===
                              formatDateString(
                                today.getFullYear(),
                                today.getMonth(),
                                today.getDate()
                              );

                            return (

                              <button
                                type="button"
                                key={`${item.date || "empty"}-${index}`}
                                className={`
                                  calendar-day
                                  ${
                                    !item.currentMonth
                                      ? "outside-month"
                                      : ""
                                  }
                                  ${
                                    isSelected
                                      ? "selected"
                                      : ""
                                  }
                                  ${
                                    isToday
                                      ? "today"
                                      : ""
                                  }
                                  ${
                                    isPast
                                      ? "disabled"
                                      : ""
                                  }
                                `}
                                disabled={
                                  !item.currentMonth ||
                                  isPast
                                }
                                onClick={() =>
                                  handleDateSelect(
                                    item.date
                                  )
                                }
                              >
                                {item.day}
                                {isToday &&
                                  item.currentMonth && (
                                    <span className="today-dot" />
                                  )}
                              </button>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="booking-time-column">
                  <div className="booking-field time-field">
                    <label>
                      <FiClock />
                      Select a time
                    </label>

                    <p className="pricing-pdf-special-note">
                      <span>
                        Note: All times are shown
                        according to Asia/Kolkata
                        time zone.
                      </span>
                    </p>

                    {!selectedDate ? (
                      <div className="time-empty-state">
                      <div className="time-empty-icon">
  <FiCalendar />
</div>
                        <strong>
                          Choose a date to see
                          available slots
                        </strong>
                        <p className="section-text">
                          Available time slots
                          will appear here once
                          you select a date.
                        </p>
                      </div>

                    ) : (
                      <>

                       <p className="available-time-text">
    Available time slots for{" "}
    <strong>{formatSelectedDate(selectedDate)}</strong>
  </p>

  {slotsLoading ? (
    <p className="section-text">Loading available slots...</p>
  ) : slotsError ? (
    <p className="section-text">{slotsError}</p>
  ) : timeSlots.length === 0 ? (
    <p className="section-text">
      No available time slots for this date. Please select another date.
    </p>
  ) : (
    <div className="time-options">
      {timeSlots.map((time) => {
        const isSelected = selectedTime === time;

        return (
          <button
            type="button"
            key={time}
            className={`time-option ${
              isSelected ? "selected" : ""
            }`}
            onClick={() => setSelectedTime(time)}
            disabled={slotsLoading}
          >
            {isSelected && <FiCheck />}
            {time}
          </button>
        );
      })}
    </div>
  )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="booking-contact-fields">
   <motion.div
        className="input-group"
        variants={fadeUp}
      >
        <label htmlFor="name">
          Company Name *
        </label>
        <div className="input-box">
          <FiBriefcase />
          <input
            type="text"
            id="companyName"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
            placeholder="Enter Your Company Name"
          />
        </div>
      </motion.div>

   <motion.div
        className="input-group"
        variants={fadeUp}
      >
        <label htmlFor="name">
         Work Email *
        </label>
        <div className="input-box">
          <FiMail/>
          <input
            type="email"
            id="workEmail"
            name="workEmail"
            value={formData.workEmail}
            onChange={handleChange}
            placeholder="Enter Your Work Email"
          />
        </div>
      </motion.div>

</div>

              <div className="booking-actions">
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={
                    !selectedDate ||
                    !selectedTime
                  }
                  onClick={
                    handleNextStep
                  }
                >
                  Next
                  <FiArrowRight />
                </button>
              </div>
            </div>
          </div>
        )}

        {/* =====================================
            STEP 2
        ====================================== */}

        {bookingStep === 2 && (

          <div className="booking-step">
            <div className="booking-step-header">
              <div>
                <h2 className="section-heading">
                  Tell us about yourself
                </h2>
              <p className="section-text">
  Share a few details about your project and requirements
  so we can prepare a more relevant and useful demo for you.
</p>
            </div>
            </div>
            <div className="book-demo-right">
       <form className="book-a-demo-form" onSubmit={handleBookingSubmit}>
  {/* Full Name */}
  <motion.div
    className="input-group"
    variants={fadeUp}
  >
    <label htmlFor="fullName">
      Full Name *
    </label>

    <div className="input-box">
      <FiUser />

      <input
        type="text"
        id="fullName"
        name="fullName"
        value={formData.fullName}
        onChange={handleChange}
        placeholder="Enter Your Full Name"
      />
    </div>
  </motion.div>

  {/* Phone Number */}
  <motion.div
    className="input-group"
    variants={fadeUp}
  >
    <label htmlFor="phoneNumber">
      Phone Number *
    </label>
    <div className="input-box phone-input-box">
      <PhoneInput
        country="in"
        value={formData.phoneNumber}
        onChange={(phone) =>
          setFormData((prev) => ({
            ...prev,
            phoneNumber: phone,
          }))
        }
        inputProps={{
          id: "phoneNumber",
          name: "phoneNumber",
          required: true,
        }}
        placeholder="Enter Your Phone Number"
      />
    </div>
  </motion.div>


  {/* Project Brief */}
  <motion.div
    className="input-group"
    variants={fadeUp}
  >
    <label htmlFor="projectBrief" className="textarea-label">
      Project Brief *
    </label>
    <div className="input-box textarea-box">
      <FiFileText />
      <textarea
        id="projectBrief"
        name="projectBrief"
        value={formData.projectBrief}
        onChange={handleChange}
        placeholder="Tell us briefly about your project"
        rows="4"
      />
    </div>
  </motion.div>


  {/* How Did You Find Us */}
  <motion.div
    className="input-group find-us-field"
    variants={fadeUp}
  >
    <label>
      How did you find us? *
    </label>
    <div className="find-us-options">
      {[
        "Google",
        "AI",
        "YouTube",
        "Someone Referred",
        "LinkedIn",
        "Instagram",
        "Facebook",
        "Other",
      ].map((option) => (
      <label
  key={option}
  className={`find-us-option ${
    formData.howDidYouFindUs.includes(option)
      ? "selected"
      : ""
  }`}
>
  <input
    type="checkbox"
    name="howDidYouFindUs"
    value={option}
    checked={formData.howDidYouFindUs.includes(option)}
    onChange={(e) => {
      const { value, checked } = e.target;

      setFormData((prev) => ({
        ...prev,
        howDidYouFindUs: checked
          ? [...prev.howDidYouFindUs, value]
          : prev.howDidYouFindUs.filter(
              (item) => item !== value
            ),
      }));
    }}
  />
  <span>{option}</span>
</label>
      ))}
    </div>
  </motion.div>

  {/* Form Actions */}
  <div className="booking-actions">
    <button
      type="submit"
      className="btn btn-demo"
      disabled={loading}
    >
      {loading
        ? "Booking..."
        : "Book My Demo"}
    </button>
  </div>
</form>
            </div>
          </div>
        )}
      </motion.div>
    </div>
  </div>
</section>
    </>
  );
};
export default BookDemo;